/* __next_internal_client_entry_do_not_use__ Grid auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { getSpacing } from "@faire/web--source/slate/spacing";
import React from "react";
import styled from "styled-components";
import { buildResponsiveCss } from "../Theme/ResponsiveCss";
import { highVisSlateComponent, HIGH_VIS_FILTER } from "../utils/highVisSlateComponent";
var defaultColumnTemplate = function(columns) {
    return "repeat(".concat(columns, ", 1fr);");
};
/**
 * @trackcomponent
 */ export var Grid = function(props) {
    var children = props.children, columns = props.columns, gap = props.gap, rowGap = props.rowGap, columnGap = props.columnGap, columnTemplate = props.columnTemplate, rest = _object_without_properties(props, [
        "children",
        "columns",
        "gap",
        "rowGap",
        "columnGap",
        "columnTemplate"
    ]);
    return /*#__PURE__*/ _jsx(StyledGrid, _object_spread_props(_object_spread({
        $columns: columns,
        $gap: gap,
        $rowGap: rowGap,
        $columnGap: columnGap,
        $columnTemplate: columnTemplate
    }, rest), {
        children: children
    }));
};
var StyledGrid = styled.div.withConfig({
    componentId: "sc-dd9de7a4-0"
})([
    "display:grid;",
    " ",
    " ",
    " overflow:hidden;",
    ""
], function(param) {
    var _param_$columns = param.$columns, $columns = _param_$columns === void 0 ? 2 : _param_$columns, _param_$columnTemplate = param.$columnTemplate, $columnTemplate = _param_$columnTemplate === void 0 ? defaultColumnTemplate : _param_$columnTemplate;
    return buildResponsiveCss("grid-template-columns", $columns, $columnTemplate);
}, function(param) {
    var _param_$gap = param.$gap, $gap = _param_$gap === void 0 ? "1x" : _param_$gap, $rowGap = param.$rowGap;
    return buildResponsiveCss("row-gap", $rowGap !== null && $rowGap !== void 0 ? $rowGap : $gap, getSpacing);
}, function(param) {
    var _param_$gap = param.$gap, $gap = _param_$gap === void 0 ? "1x" : _param_$gap, $columnGap = param.$columnGap;
    return buildResponsiveCss("column-gap", $columnGap !== null && $columnGap !== void 0 ? $columnGap : $gap, getSpacing);
}, highVisSlateComponent(HIGH_VIS_FILTER.LAYOUT));
